import React, { Component } from 'react';

class BrowseHeader extends Component {
  render() {
    return (
      <div>
        <h2>Browse</h2>
      </div>
    );
  }
}

export default BrowseHeader;


// WEBPACK FOOTER //
// ./src/Components/Browse/BrowseHeader.js